import { staticAssetsPath } from '../../../../configs/constants'
import { PersonalTabIcon, TeamsTabIcon, UsersGroup } from '../icons/Icons'
import { useSasToken } from '../../../../_hooks/useSasToken'

const imgPath = `${staticAssetsPath}/images/customPersonas`

// Hook to get avatars list with SAS tokens applied
export const useAvatarsList = () => {
  const { appendToken } = useSasToken()

  return [
    {
      id: 1,
      name: 'animalAvatar',
      icon: appendToken(`${imgPath}/animalAvatar.png`),
      isSelected: false
    },
    {
      id: 2,
      name: 'manAvatar',
      icon: appendToken(`${imgPath}/manAvatar1.png`),
      isSelected: false
    },
    {
      id: 3,
      name: 'womanAvatar',
      icon: appendToken(`${imgPath}/womanAvatar.png`),
      isSelected: false
    },
    {
      id: 4,
      name: 'manAvatar2',
      icon: appendToken(`${imgPath}/manAvatar2.png`),
      isSelected: false
    },
    {
      id: 5,
      name: 'oldManAvatar',
      icon: appendToken(`${imgPath}/manAvatar3.png`),
      isSelected: false
    },
    {
      id: 6,
      name: 'centraliAliAvatar',
      icon: appendToken(`${staticAssetsPath}/images/logo/ALI_Chatbot-vb.png`),
      isSelected: false
    },
    {
      id: 7,
      name: 'defaultAvatar',
      icon: null,
      isSelected: true
    },
    {
      id: 8,
      name: 'animalAvatar1',
      icon: appendToken(`${imgPath}/avatar1.png`),
      isSelected: false
    },
    {
      id: 9,
      name: 'animalAvatar2',
      icon: appendToken(`${imgPath}/avatar2.png`),
      isSelected: false
    },
    {
      id: 10,
      name: 'animalAvatar3',
      icon: appendToken(`${imgPath}/avatar3.png`),
      isSelected: false
    },
    {
      id: 11,
      name: 'animalAvatar4',
      icon: appendToken(`${imgPath}/avatar4.png`),
      isSelected: false
    },
    {
      id: 12,
      name: 'animalAvatar5',
      icon: appendToken(`${imgPath}/avatar5.png`),
      isSelected: false
    },
    {
      id: 13,
      name: 'animalAvatar6',
      icon: appendToken(`${imgPath}/avatar6.png`),
      isSelected: false
    },
    {
      id: 14,
      name: 'animalAvatar7',
      icon: appendToken(`${imgPath}/avatar7.png`),
      isSelected: false
    },
    {
      id: 15,
      name: 'animalAvatar8',
      icon: appendToken(`${imgPath}/avatar8.png`),
      isSelected: false
    },
    {
      id: 16,
      name: 'animalAvatar9',
      icon: appendToken(`${imgPath}/avatar9.png`),
      isSelected: false
    },
    {
      id: 17,
      name: 'centraliAliAvatar',
      icon: appendToken(`${staticAssetsPath}/images/logo/ALI_Chatbot-vb.png`),
      isSelected: false
    }
  ]
}

// Legacy export for backward compatibility (without tokens)
const avatarsList: any = [
  {
    id: 1,
    name: 'animalAvatar',
    icon: `${imgPath}/animalAvatar.png`,
    isSelected: false
  },
  {
    id: 2,
    name: 'manAvatar',
    icon: `${imgPath}/manAvatar1.png`,
    isSelected: false
  },
  {
    id: 3,
    name: 'womanAvatar',
    icon: `${imgPath}/womanAvatar.png`,
    isSelected: false
  },
  {
    id: 4,
    name: 'manAvatar2',
    icon: `${imgPath}/manAvatar2.png`,
    isSelected: false
  },
  {
    id: 5,
    name: 'oldManAvatar',
    icon: `${imgPath}/manAvatar3.png`,
    isSelected: false
  },
  {
    id: 6,
    name: 'centraliAliAvatar',
    icon: `${staticAssetsPath}/images/logo/ALI_Chatbot-vb.png`,
    isSelected: false
  },
  {
    id: 7,
    name: 'defaultAvatar',
    icon: null,
    isSelected: true
  },
  {
    id: 8,
    name: 'animalAvatar1',
    icon: `${imgPath}/avatar1.png`,
    isSelected: false
  },
  {
    id: 9,
    name: 'animalAvatar2',
    icon: `${imgPath}/avatar2.png`,
    isSelected: false
  },
  {
    id: 10,
    name: 'animalAvatar3',
    icon: `${imgPath}/avatar3.png`,
    isSelected: false
  },
  {
    id: 11,
    name: 'animalAvatar4',
    icon: `${imgPath}/avatar4.png`,
    isSelected: false
  },
  {
    id: 12,
    name: 'animalAvatar5',
    icon: `${imgPath}/avatar5.png`,
    isSelected: false
  },
  {
    id: 13,
    name: 'animalAvatar6',
    icon: `${imgPath}/avatar6.png`,
    isSelected: false
  },
  {
    id: 14,
    name: 'animalAvatar7',
    icon: `${imgPath}/avatar7.png`,
    isSelected: false
  },
  {
    id: 15,
    name: 'animalAvatar8',
    icon: `${imgPath}/avatar8.png`,
    isSelected: false
  },
  {
    id: 16,
    name: 'animalAvatar9',
    icon: `${imgPath}/avatar9.png`,
    isSelected: false
  },
  {
    id: 17,
    name: 'centraliAliAvatar',
    icon: `${staticAssetsPath}/images/logo/ALI_Chatbot-vb.png`,
    isSelected: false
  }
]

const agentValidationMessages = {
  agentName: 'Agent name is mandatory',
  appDescription: 'Description is mandatory'
}

const agentTabItems = [
  // {
  //   id: '1',
  //   name: 'Favourites',
  //   icon: <Favourite size={24} />
  // },
  {
    id: '1',
    name: 'Personal',
    icon: <PersonalTabIcon size={24} />
  },
  {
    id: '2',
    name: 'Teams',
    icon: <TeamsTabIcon size={24} />
  },
  {
    id: '3',
    name: 'Enterprise',
    icon: <UsersGroup size={24} />
  }
]

const gptModelOptions = [
  {
    id: 1,
    value: 'GPT 3.5',
    label: 'GPT 3.5'
  },
  {
    id: 2,
    value: 'GPT 4',
    label: 'GPT 4o'
  }
]

export { avatarsList, agentValidationMessages, agentTabItems, imgPath, gptModelOptions }
